interface FeedBackProps {
    correct: Boolean,
    itemId: number
}

function FeedBack(props: FeedBackProps): JSX.Element {
    let goodSrcs: string[] = ["/aplodit_palaute.mp4", "/hieno_palaute.mp4", "/jees_ele_palaute.mp4"];
    let badSrcs: string[] = ["/harmi_ele_palaute.mp4", "/harmi_palaute.mp4"];

    let randomGoodFeedBack = Math.floor(Math.random() * goodSrcs.length);
    let randomBadFeedBack = Math.floor(Math.random() * badSrcs.length);

    let feedBackSrc = props.correct ? goodSrcs[randomGoodFeedBack] : badSrcs[randomBadFeedBack];
    let borderColor = props.correct ? "border-green-500" : "border-red-500";

    const feedBack = (
        <div className="justify-center">
            <div className={"flex w-full h-full text-center overflow-hidden bg-white border-8 rounded-2xl " + borderColor}>
                <video key={"feedBackVideo_" + props.itemId + props.correct} src={feedBackSrc} preload="auto" autoPlay />
            </div>
        </div>
    );

    return feedBack;
}

export default FeedBack;